import { getQueryParamValue } from '@nw/shared/utils';

export const APP_CODE_QUERY_PARAM = 'application_id';
export const NIAT_2027_APPLICATION_ID = 'fb15bec2-c075-46ad-a2e9-28156294182c';
export const NIAT_APPLICATION_2026 = 'NIAT_2026';
export const NIAT_APPLICATION_2027 = 'NIAT_2027';

export const resolveNiatApplicationEnum = (
  url?: string
): typeof NIAT_APPLICATION_2026 | typeof NIAT_APPLICATION_2027 => {
  const appCode =
    url === undefined
      ? getQueryParamValue(APP_CODE_QUERY_PARAM)
      : getQueryParamValue(APP_CODE_QUERY_PARAM, url);

  if (appCode === NIAT_2027_APPLICATION_ID) {
    return NIAT_APPLICATION_2027;
  }

  return NIAT_APPLICATION_2026;
};
